import { render, staticRenderFns } from "./AboutServices.vue?vue&type=template&id=e4e6f68c&scoped=true&"
import script from "./AboutServices.vue?vue&type=script&lang=ts&"
export * from "./AboutServices.vue?vue&type=script&lang=ts&"
import style0 from "./AboutServices.vue?vue&type=style&index=0&id=e4e6f68c&lang=stylus&scoped=true&"
import style1 from "./AboutServices.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e6f68c",
  null
  
)

export default component.exports